export enum CountryCodeEnum {
    // Add all the coutry codes only in lower case
    US = 'us',
    CA = 'ca'
}
